/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'chat.bsky.moderation.getActorMetadata'

export { $nsid }

const main = l.query(
  $nsid,
  l.params({ actor: l.string({ format: 'did' }) }),
  l.jsonPayload({
    day: l.ref<Metadata>((() => metadata) as any),
    month: l.ref<Metadata>((() => metadata) as any),
    all: l.ref<Metadata>((() => metadata) as any),
  }),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $output = main.output

type Metadata = {
  $type?: 'chat.bsky.moderation.getActorMetadata#metadata'
  messagesSent: number
  messagesReceived: number
  convos: number
  convosStarted: number
}

export type { Metadata }

const metadata = l.typedObject<Metadata>(
  $nsid,
  'metadata',
  l.object({
    messagesSent: l.integer(),
    messagesReceived: l.integer(),
    convos: l.integer(),
    convosStarted: l.integer(),
  }),
)

export { metadata }
